import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {UniversityPopularCourseService} from '../../../shared/services/university-popular-course.service';
import {PopularCourseService} from '../../../shared/services/popular-course.service';
import {AlertService} from '../../../shared/services/alert.service';

@Component({
    selector: 'app-university-popular-courses',
    templateUrl: './university-popular-courses.component.html',
    styleUrls: ['./university-popular-courses.component.scss']
})
export class UniversityPopularCoursesComponent implements OnInit {
    universityId: any;
    showLinkPanel = false;
    searchForm: FormGroup;
    searching = false;
    submitting = false;
    linkedCourses = [];
    allCatalogCourses = [];
    catalogCourses = [];
    selectedIds = new Set<number>();

    constructor(private activatedRoute: ActivatedRoute,
                private fb: FormBuilder,
                private universityPopularCourseService: UniversityPopularCourseService,
                private popularCourseService: PopularCourseService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.searchForm = this.fb.group({
            'course': ['']
        });
        this.searchForm.get('course').valueChanges.pipe(
            debounceTime(300),
            distinctUntilChanged()
        ).subscribe(() => this.filterCatalog());
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.get();
    }

    get(): void {
        this.submitting = true;
        this.universityPopularCourseService.get(this.universityId).subscribe(data => {
            this.linkedCourses = Array.isArray(data) ? data : [];
            this.submitting = false;
        }, () => {
            this.submitting = false;
        });
    }

    toggleLinkPanel(): void {
        this.showLinkPanel = !this.showLinkPanel;
        this.selectedIds.clear();
        this.searchForm.patchValue({'course': ''});
        if (this.showLinkPanel) {
            this.loadCatalog();
        } else {
            this.catalogCourses = [];
        }
    }

    loadCatalog(): void {
        this.searching = true;
        this.popularCourseService.get({page: -1}).subscribe(data => {
            this.allCatalogCourses = Array.isArray(data) ? data : ((data && data['data']) ? data['data'] : []);
            this.filterCatalog();
            this.searching = false;
        }, () => {
            this.searching = false;
        });
    }

    filterCatalog(): void {
        const term = (this.searchForm.value && this.searchForm.value.course) ? this.searchForm.value.course.trim().toLowerCase() : '';
        const linkedIds = new Set(this.linkedCourses.map(c => c.id));
        this.catalogCourses = this.allCatalogCourses.filter(c =>
            !linkedIds.has(c.id) &&
            (!term
                || (c.course && c.course.toLowerCase().includes(term))
                || (c.short_name && c.short_name.toLowerCase().includes(term)))
        );
    }

    toggleSelected(course): void {
        if (this.selectedIds.has(course.id)) {
            this.selectedIds.delete(course.id);
        } else {
            this.selectedIds.add(course.id);
        }
    }

    isSelected(course): boolean {
        return this.selectedIds.has(course.id);
    }

    linkSelected(): void {
        if (this.selectedIds.size === 0) {
            return;
        }
        this.submitting = true;
        this.universityPopularCourseService.link(this.universityId, Array.from(this.selectedIds)).subscribe(() => {
            this.submitting = false;
            this.alertService.showSuccess({title: 'Success', message: 'Courses linked successfully'});
            this.toggleLinkPanel();
            this.get();
        }, () => {
            this.submitting = false;
        });
    }

    unlink(course): void {
        this.submitting = true;
        this.universityPopularCourseService.unlink(this.universityId, course.id).subscribe(() => {
            this.submitting = false;
            this.get();
        }, () => {
            this.submitting = false;
        });
    }
}
